import env from "../env";
import {setRecoil} from "recoil-nexus";
import {accessTokenState} from "../recoil/atoms/accessTokenState";
import {expiresInState} from "../recoil/atoms/expiresInState";

export function login(data) {
    return fetch(env.apiUrl+"api/Login", {
        method: "POST",
        mode: "cors",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
    }).then(async resp => {
        const body = await resp.json()
        if ('needChallenge' in body) {
            return body
        }
        const {
            accessToken,
            expiresIn
        } = body?.accessToken
        setRecoil(accessTokenState, accessToken);
        setRecoil(expiresInState, expiresIn);
        return body?.loginResponse
    })
}

export function loginExternal(token) {
  return fetch(env.apiUrl+"api/login/external", {
    method: "POST",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ token })
  }).then(async resp => {
    const body = await resp.json()
    const {
      accessToken,
      expiresIn
    } = body?.accessToken
    setRecoil(accessTokenState, accessToken);
    setRecoil(expiresInState, expiresIn);
    return body?.loginResponse
  })
}

export function LoginPortalFinanceiro(obj) {
  return fetch(`${process.env.REACT_APP_API}v1/authentication/externalsmo`, {
    method: "POST",
    mode: "cors",
    headers: {
      Authorization: `Basic ${process.env.REACT_APP_BASIC_AUTHENTICATION}`,
      "Content-Type": "application/json"
    },
    body: JSON.stringify(obj)
  })
}
